import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SnackBarService } from 'src/app/services/snackBar/snack-bar.service';
import { TicketsService } from 'src/app/services/tickets/tickets.service';

@Component({
  selector: 'app-caso-detail',
  templateUrl: './caso-detail.component.html',
  styleUrls: ['./caso-detail.component.scss'],
})
export class CasoDetailWebComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  id: number;

  ticket: any = null;

  nuevoSeguimiento = false;

  textoSeguimiento: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private ticketsSvc: TicketsService,
    private snackBarService: SnackBarService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = +params['id'];
      console.log('ID capturado:', this.id);
      this.loadTicket(this.id);
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  goBack() {
    this.router.navigate(['/casos']);
  }

  goSeguimiento() {
    this.router.navigate([`/seguimiento/${this.id}`]);
  }

  buscarEstadoPorNombre(nombre: string) {
    return this.translocoService.translate('issues.status.' + nombre);
  }

  nuevoSeguimientoF() {
    this.nuevoSeguimiento = !this.nuevoSeguimiento;
  }

  crearNuevoSeguimiento() {
    this.ticketsSvc
      .crearSeguimiento(this.id, this.textoSeguimiento)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (v) => {
          console.log(v);
          this.loadTicket(this.id);
          this.nuevoSeguimiento = false;
        },
        error: (e) => {
          this.showSnackBarError(
            this.translocoService.translate('issue.error.tracking')
          );
        },
      });
  }

  showSnackBarError(mensaje: string) {
    this.snackBarService.openSnackBarError(mensaje);
  }

  loadTicket(ticket: any) {
    this.ticketsSvc
      .buscarTicket(ticket)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (v) => {
          console.log(v);
          this.ticket = v;
        },
        error: (e) => {
          console.log(e);
          this.showSnackBarError(
            this.translocoService.translate('issue.error.loadTicket')
          );
          this.router.navigate(['/casos']);
        },
      });
  }
}
